// extracted by mini-css-extract-plugin
export default {"EntityWraps":"horizontal-card-listing_EntityWraps__whFLa"};